import { useContext } from "react";
import { initialLoginState } from "@context/Auth/AuthState";
import authContext from "@context/Auth/authContext";
import checkCloseTableContext from "@context/CheckCloseInformationTable/checkCloseTableContext";
import checkOpenTableContext from "@context/CheckOpenInformationTable/checkOpenTableContext";
import NotificationContext from "@context/Notification/notificationContext";
import NotificationCountContext from "@context/NotificationCount/notificationCountContext";
import LocationContext from "@context/location/locationContext";
import {
  TAB_TYPE,
  initialNotificationFilterTypes,
} from "@pages/Dashboard/Notification/helper";

export function clearContextEventTrigger() {
  const event = new Event("clearContextEvent");
  window.dispatchEvent(event);
}

const useClearContext = () => {
  const [{ setState }] = useContext(authContext);
  const [{ locationSetState }] = useContext(LocationContext);
  const [{ notificationSetState }] = useContext(NotificationContext);
  const [{ notificationCountStateSetState }] = useContext(
    NotificationCountContext
  );
  const [{ checkOpenTableSetState }] = useContext(checkOpenTableContext);
  const [{ checkCloseTableSetState }] = useContext(checkCloseTableContext);

  const resetContext = () => {
    const initialLocationState = {
      property: "",
      revenueCenter: "",
      store: "",
      date: "",
    };

    const initialCheckState = {
      identifier: "time",
      page: 0,
      sortingType: "desc",
    };

    const initialNotificationState = {
      currentTab: TAB_TYPE.UNREAD,
      filterType: initialNotificationFilterTypes,
    };

    locationSetState(initialLocationState);
    notificationSetState(initialNotificationState);
    notificationCountStateSetState({ count: 0 });
    setState(initialLoginState);
    checkOpenTableSetState(initialCheckState);
    checkCloseTableSetState(initialCheckState);
  };

  return resetContext;
};

export default useClearContext;
